import React from 'react';
import {Stack, Typography, Divider} from '@mui/material';

import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {FlowEnum} from '../../constants';
import {SuggestionCardProps} from './types';
import {SpecialtyCard} from '../SpecialtyCard';
import {SUGGESTED_SPECIALTY} from 'presentation/modules/booking/shared/constants/suggestedSpecialty';

const {suggestedSpecialties} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow;

export function SuggestionCard({
	flowType,
	handleSelectCard,
	recommendationArr,
}: SuggestionCardProps) {
	const {
		beneficiary: {idadeC},
	} = useAccountDataStore(state => state.accountData);
	const {SEARCH_PARAMS} = useQueryParams();

	const {searchByLetter} = SEARCH_PARAMS;
	const isOdonto = flowType === FlowEnum.ODONTO;
	const isExam = flowType === FlowEnum.EXAM;
	const isPediatric = idadeC < 18;

	const odontoSuggestion = isPediatric
		? SUGGESTED_SPECIALTY.generalPediatricOdonto
		: SUGGESTED_SPECIALTY.generalAdultOdonto;

	if (isExam || recommendationArr.length === 0 || searchByLetter) {
		return null;
	}

	const specialtyFormatted = formatText(
		isOdonto ? odontoSuggestion.formattedText : recommendationArr[0].formattedText,
	);

	return (
		<Stack gap={2}>
			<Typography variant="subheader">{suggestedSpecialties}</Typography>
			<SpecialtyCard
				dataTagId={AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_SUGERIDA}
				textDataTagId={AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_SUGERIDA_TEXT}
				text={specialtyFormatted}
				handleClick={() => handleSelectCard(recommendationArr[0])}
				selected={false}
				isSuggestionCard
				specialtyCode={recommendationArr[0].code}
			/>
			<Divider />
		</Stack>
	);
}
